import { render, staticRenderFns } from "./WebWorkflowAntragVerfallzeit.vue?vue&type=template&id=ab655a24&scoped=true"
import script from "./WebWorkflowAntragVerfallzeit.vue?vue&type=script&lang=ts"
export * from "./WebWorkflowAntragVerfallzeit.vue?vue&type=script&lang=ts"
import style0 from "./WebWorkflowAntragVerfallzeit.vue?vue&type=style&index=0&id=ab655a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab655a24",
  null
  
)

export default component.exports